import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.reportProgress && !(req.body instanceof FormData)) {
      return next.handle( 
        req.clone({ 
          headers : req.headers
            .set('Content-Type', req.headers.get('Content-Type') ?? 'application/json'),
        }),
      )
    } else {
      return next.handle(req)
    }
  }
}
